import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const TitleWrapper = styled(Box)(({ theme }) => ({
  paddingTop: '18px',
  paddingBottom: '18px',
  paddingLeft: '36px',
  borderBottom: `1px solid ${theme.palette.secondary.main}`,
}))

export const Content = styled(Box)(({ theme }) => ({
  padding: '36px 36px 0 36px',
}))

export const ContentItems = styled(Box)(({ theme }) => ({
  maxHeight: '60vh',
  overflowY: 'auto',
  borderBottom: `1px solid ${theme.borders?.grey ?? theme.palette.grey[300]}`,
}))

export const TenantItem = styled(Box)(({ theme }) => ({
  padding: '20px 24px',
  borderTop: `1px solid ${theme.borders?.grey ?? theme.palette.grey[300]}`,
  cursor: 'pointer',
  outline: 'none',
}))

export const OddTenant = styled(TenantItem)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
}))

export const SelectedTenant = styled(TenantItem)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.secondary.main,
}))

export const Footer = styled(Box)(({ theme }) => ({
  padding: '48px 36px',
  display: 'flex',
  justifyContent: 'flex-end',
}))

export const SecondaryButtonWrapper = styled(Box)(() => ({
  marginRight: '20px',
}))
